module.exports = __webpack_public_path__ + "static/Hamburg-photo-23838745ee666a61197a9d46120fbc7c.png";